// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"5ebd6efa","178":"f20d9e4e","541":"0352712b","570":"ed4a79ce","689":"45ceafa9"}[chunkId] + ".chunk.js";
};